// See src/OrderPipe/Steps/WebBusiness/MVC/BaseStepsMvcWeb/Controllers/CrossSellBasket/CrossSellBasketController.cs
import { DEFAULT_OFFER } from '../../../../Assets/helpers/product/product.js';

const offerPattern = '[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}';
const productIdentifier = new RegExp(String.raw`^(\d+)(?:-(${offerPattern})|\((\d+)\))?$`, 'i');

/** @typedef {import('./typedefs.js').CartProduct} CartProduct */

/**
 * Parse product from input value to object
 *
 * @example
 *   parseProductDataFromValue('1-00000000-0000-0000-0000-000000000000') ===
 *     { prid: '1', offer: '00000000-0000-0000-0000-000000000000' }; // marketplace offer without catalog
 *
 * @example
 *   parseProductDataFromValue('1_3-00000000-0000-0000-0000-000000000000') ===
 *     { prid: '1', offer: '00000000-0000-0000-0000-000000000000', catalog: '3' }; // marketplace offer
 *
 * @example
 *   parseProductDataFromValue('1234(5678)') === { prid: '5678', relatedPrid: '1234' }; // service
 *
 * @example
 *   parseProductDataFromValue('1234') === { prid: '5678', relatedPrid: '1234' }; // service
 *
 * @param {string} value
 * @returns {CartProduct | null}
 */
const parseProductDataFromValue = (value) => {
  if (value === null) {
    return null;
  }

  if (value.includes('_')) {
    // format is '1-3_00000000-0000-0000-0000-000000000000'
    // it's set in  www\Nav\Core\Mobile\Views\Product\Common\Price\_ArticleOffersOneOffer.cshtml
    // and parsed in  CommunityController::StoreLocatorWithAvailability
    // i don't want to modifiy this dangerous regex (see above).
    // catalog may not be used by Pipe, because it gets product from offer's reference.
    const parts = value.split('_');
    const productParts = parts[0].split('-');
    const prid = productParts[0];
    const catalog = productParts[1];
    const offer = parts[1];

    return {
      prid: prid,
      offer,
      catalog: catalog,
      relatedPrid: null
    };
  }

  const result = value.match(productIdentifier);
  if (result == null) {
    return null;
  }

  const [, prid, offer = DEFAULT_OFFER, service = null] = result;
  return {
    prid: service ?? prid,
    offer,
    relatedPrid: service ? prid : null
  };
};
export default parseProductDataFromValue;
